"use client";

import BentoBox from ".";
import { defaultSectionBentoTabsOrderData } from "./default";
import type { SectionBentoTabsOrder } from "./types.base";

interface BaseBentoTabsOrderProps {
  data?: SectionBentoTabsOrder;
}

export default function BaseBentoTabsOrder({
  data = defaultSectionBentoTabsOrderData,
}: BaseBentoTabsOrderProps) {
  return (
    <BentoBox
      defaultTab={data.defaultTab || "mobile"}
      tabOrder={data.order}
      sectionTitle={data.title}
      sectionSubtitle={data.subTitle}
      containerClassName=""
    />
  );
}
